// export const formatUrl = (url: string, params: (string | number | undefined)[]): string => {
//     let formattedUrl = url;
//     params.forEach((param, index) => {
//       const placeholder = `{${index}}`;
//       formattedUrl = formattedUrl.replace(placeholder, param?.toString() ?? '');
//     });
//     return formattedUrl;
//   };
//@ts-nocheck
export const formatUrl = (url: string, params: (string | number)[]): string => {
    return params.reduce((formattedUrl, param, index) => {
      const placeholder = `{${index}}`;
      return formattedUrl.replace(placeholder, param.toString());
    }, url);
  };
  